import { Browser } from "@capacitor/browser";
import { Button, fontMedium } from "swing-components";

import { BUILD_PROFILE } from "~utils";

/***** Constants *****/
// URL for the web application which the Sub should use when they are on a
// mobile device.
const WEB_URL =
  // Local
  BUILD_PROFILE === "local"
    ? "http://localhost:3001"
    : // Staging
      BUILD_PROFILE === "staging"
      ? "https://swingsubs.aws.swingeducation.com"
      : // Production
        "https://swingsubs.swingeducation.com/";

/**
 * Renders copy when a Sub is completing onboarding via a mobile (iOS, Android)
 * device.
 */
export function WebOnlyConfiguration() {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        padding: "120px 32px",
        maxWidth: 800,
        margin: "0 auto",
      }}
    >
      <p css={[fontMedium({ fontWeight: 600 }), { margin: 0 }]}>Onboarding Available on Web</p>
      <p css={[fontMedium(), { margin: 0 }]}>
        To complete your onboarding, please{" "}
        <a onClick={() => Browser.open({ url: WEB_URL })}>click here</a> to continue.
      </p>
      <Button type="primary" onClick={() => Browser.open({ url: WEB_URL })}>
        Continue on Web
      </Button>
    </div>
  );
}
